import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { firmSlugGuard } from './firm-slug-guard';
import { IntakeSession } from './intake-session';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./intake-flow/intake-flow'),
    canActivate: [firmSlugGuard],
  },
  {
    path: 'error',
    loadComponent: () => import('./error/error'),
  },
  {
    path: 'confirmation',
    loadComponent: () => import('./submission-confirmation/submission-confirmation'),
    canActivate: [
      (route) => {
        const intakeSession = inject(IntakeSession);
        const router = inject(Router);

        const firm = route.queryParams['firm'] || intakeSession.firmSlug();
        if (!firm) {
          return router.createUrlTree(['/error'], { queryParams: { reason: 'missing-firm' } });
        }

        if (!intakeSession.hasToken()) {
          return router.createUrlTree(['/'], {
            queryParams: { firm },
          });
        }

        if (!intakeSession.draft()) {
          return router.createUrlTree([intakeSession.nextIncompleteStep()], {
            queryParams: { firm },
          });
        }

        return true;
      },
    ],
  },
];
